import React from "react";
import { Upload, Space, Typography, Tooltip, Form } from "antd";
import {
  InboxOutlined,
  FileOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const { Dragger } = Upload;

export default function InsuranceUploader({
  uploadProps,
  existingFiles,
  handleDeleteFile,
}) {
  return (
    <div className="files">
      <div className="file-upload">
        <label>Add Employer's insurance liability document</label>
        <div className="upload-component">
          <Dragger {...uploadProps} className="dropbox">
            <div className="box-content">
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </div>
          </Dragger>
        </div>
      </div>

      <div className="existing">
        <label>Existing document</label>
        {existingFiles ? (
          <Space className="fileList-Item">
            <FileOutlined />
            <Typography.Text>{existingFiles?.fileName}</Typography.Text>
            <DeleteOutlined
              onClick={() => handleDeleteFile(existingFiles?.documentId)}
            />
          </Space>
        ) : (
          <Space className="fileList-Item">
            <Typography.Text>No document uploaded</Typography.Text>
          </Space>
        )}
      </div>

      <div className="file-upload">
        <Form.Item>
          <div className="info-icon expOfWorkDocument">
            <Tooltip title="Upload .Pdf or .Doc files only">
              <QuestionCircleOutlined />
            </Tooltip>
          </div>
        </Form.Item>
      </div>
    </div>
  );
}
